<div class="wrapper">
	<app-usa-banner class="no-print"></app-usa-banner>
	<app-nav-bar></app-nav-bar>
	<!-- <app-message-banner></app-message-banner> -->
	<div class="page-body">
		<router-outlet />
	</div>
	<app-footer></app-footer>
</div>
<app-toast-container />
<!-- <div class="background"></div> -->
<!-- For Full Page Static Background -->
<!-- <div [hidden]="!busy">
	<app-spinner></app-spinner>
</div> -->
